var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ClentHome"},[_c('HomeHeader'),_c('router-view',{staticClass:"HomeBody"}),_c('HomeBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }